// extracted by mini-css-extract-plugin
module.exports = {"VpcCidr":"VpcCidr_rrtka"};